import {BehaviorSubject, Observable} from 'rxjs';
import {switchMap, filter, startWith, shareReplay, tap, map} from 'rxjs/operators';
import {abtestApi} from '@px/api/abtest';
import {authStatus$} from '@px/streams/auth';

export const isInitSpotPnlABTestState$ = new BehaviorSubject<boolean>(true);

export const spotPnlABTestState$: Observable<boolean> = authStatus$.pipe(
  tap((status) => {
    if (status === 'Logout') {
      isInitSpotPnlABTestState$.next(false);
    }
  }),
  filter((status) => status === 'Login'),
  switchMap(() => abtestApi.commonAbtest({type: 'PNL_INTERNAL'})),
  tap(() => {
    isInitSpotPnlABTestState$.next(false);
  }),
  map(({data}) => data && data.experiment === 1),
  startWith(false),
  shareReplay(1)
);
